import React, { useContext } from "react";
import PropTypes from "prop-types";

import { ALL_DIRECTIONS_QUERY } from "../../../../graphql/Directions/Directions.graphql";

import { EditDirectionForm } from "../../../../components/Directions";

import { ModalContext } from "../../../../components/ModalProvider";

import DataTable from "../../../../components/DataTable";

import { COLUMNS } from "../../Directions/columns";

const Directions = ({ locationRecId, filters }) => {
  const { setModalOpen } = useContext(ModalContext);

  const where = Object.keys(filters).length
    ? { ...filters, DestinationLocationRecIdRef: parseInt(locationRecId) }
    : {
        DestinationLocationRecIdRef: parseInt(locationRecId)
      };

  return (
    <div>
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_DIRECTIONS_QUERY}
        initialSortBy={[
          { id: "OriginLocationId", desc: false },
          { id: "Priority", desc: false }
        ]}
        name="Direction"
        where={{
          ...where
        }}
        onRowClick={data =>
          setModalOpen(
            true,
            <EditDirectionForm
              RecId={data.RecId}
              direction={data}
              setModalOpen={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </div>
  );
};

Directions.propTypes = {
  filters: PropTypes.object,
  locationRecId: PropTypes.number.isRequired
};
Directions.defaultProps = {
  filters: {}
};
export default Directions;
